import React, { useRef, useEffect } from "react";

const OTPInput = ({
  value = "",
  onChange,
  numInputs = 6,
  onComplete,
  disabled = false,
  error = ""
}) => {
  const inputRefs = useRef([]);

  useEffect(() => {
    // Focus first input on mount
    if (inputRefs.current[0]) {
      inputRefs.current[0].focus();
    }
  }, []);

  const handleChange = (index, e) => {
    const val = e.target.value;

    // Only allow numbers
    if (val && !/^\d$/.test(val)) return;

    const newValue = value.split("");
    newValue[index] = val;
    const finalValue = newValue.join("");

    onChange(finalValue);

    // Move to next input
    if (val && index < numInputs - 1) {
      inputRefs.current[index + 1].focus();
    }

    // Call onComplete if all inputs are filled
    if (finalValue.length === numInputs && onComplete) {
      onComplete(finalValue);
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace") {
      if (!value[index] && index > 0) {
        // Move to previous input on backspace if current is empty
        inputRefs.current[index - 1].focus();
      }
    } else if (e.key === "ArrowLeft" && index > 0) {
      inputRefs.current[index - 1].focus();
    } else if (e.key === "ArrowRight" && index < numInputs - 1) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handlePaste = (e) => {
    e.preventDefault();
    const pastedData = e.clipboardData.getData("text").slice(0, numInputs);

    // Only allow numbers
    if (!/^\d+$/.test(pastedData)) return;

    onChange(pastedData);

    // Focus the input after the last pasted character
    const focusIndex = Math.min(pastedData.length, numInputs - 1);
    inputRefs.current[focusIndex].focus();

    if (pastedData.length === numInputs && onComplete) {
      onComplete(pastedData);
    }
  };

  return (
    <div className="otp-input-wrapper">
      <div className="otp-input">
        {Array.from({ length: numInputs }).map((_, index) => (
          <input
            key={index}
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            inputMode="numeric"
            maxLength={1}
            value={value[index] || ""}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste}
            disabled={disabled}
            className={`otp-input__field ${error ? "otp-input__field--error" : ""}`}
            aria-label={`OTP digit ${index + 1}`}
          />
        ))}
      </div>
      {error && <span className="otp-input__error">{error}</span>}
    </div>
  );
};

export default OTPInput;
